import type { ComputedRef } from 'vue'
import type { DisciplineStageComment } from './interfaces'
import type { DisciplineStageCommentView } from './discipline-comments'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useListsStore } from '@shared/model'
import { resolveUrl } from '@shared/lib/url'
import { useDayjs } from '@shared/lib/format'
import { AppRoute } from '@shared/config'

import { buildStageCommentView } from './discipline-comments'

interface DisciplineCommentItemOptions {
  comment: ComputedRef<DisciplineStageComment>
}

interface DisciplineCommentItemReturn {
  refView: ComputedRef<DisciplineStageCommentView>
  refAgentUrl: ComputedRef<string | null>
  refDate: ComputedRef<string>
}

export const useDisciplineCommentItem = ({ comment }: DisciplineCommentItemOptions): DisciplineCommentItemReturn => {
  const listsStore = useListsStore()
  const dayjs = useDayjs()

  const refView = computed<DisciplineStageCommentView>(() => buildStageCommentView(comment.value, {
    channels: listsStore.getLists?.stage_comments.channel.all ?? {},
    reach: listsStore.getLists?.stage_comments.reach ?? {},
  }))

  const refAgentUrl = computed<string | null>(() =>
    comment.value.agent ? resolveUrl(AppRoute.UserEdit, { id: comment.value.agent.id }) : null)

  /** Rows arrive in the admin's view timezone. */
  const refDate = computed<string>(() => dayjs(comment.value.updated_at).format(DateFormat.KanbanDate))

  return {
    refView,
    refAgentUrl,
    refDate,
  }
}
